import React from "react";
import { Button, Input } from "reactstrap";
import { Link } from "react-router-dom";
import AddVariableProduct from "../../Products/AddVariableProduct";
import { useDispatch } from "react-redux";
import { openView } from "../../../ReduxToolkit/Reducers/viewReducer";

export default function ProductListHeader({ linkTitle, onExport, onImport }) {
  const dispatch = useDispatch();

  const handleViewOpen = (viewName) => {
    dispatch(openView(viewName));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && onImport) onImport(file);
    e.target.value = ""; // reset input
  };

  return (
    <div className="list-product-header d-flex justify-content-between align-items-center mb-3">
      <div className="d-flex gap-2 flex-wrap">
        <Button color="success" onClick={onExport}>
          📤 Export
        </Button>

        <Button
          color="warning"
          onClick={() => document.getElementById("import-file").click()}
        >
          📥 Import
        </Button>
        <Input
          id="import-file"
          type="file"
          accept=".xlsx, .xls"
          hidden
          onChange={handleFileChange}
        />

        <Link
          className="btn btn-primary"
          onClick={() => handleViewOpen("new_product")}
        >
          <i className="fa fa-plus me-2"></i> {linkTitle}
        </Link>

        <AddVariableProduct />
      </div>
    </div>
  );
}
